import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import { VARIABLES } from './constants';
import App from './App';
import Dashboard from './Dashboard';

const params = queryString.parse(window.location.search);

if (!params.p) {
  ReactDOM.render(<Dashboard />, document.getElementById('root'));
}

VARIABLES.forEach((response) => {
  if (response.name === params.p) {
    ReactDOM.render(
      <App
        botName={response.botName}
        botTitle={response.botTitle}
        headerImage={response.headerImage}
        botImage={response.botImage}
        token={response.token}
        color={response.color}
        params={params}
      />,
      document.getElementById('root')
    );
  }
});
